import { capitalizeWordsRemoveDash } from "../../../../utils/text.utils";

export default function Speficication({ speficicationData }) {

    if (!speficicationData.length) return null;

    return (<>
        <h2 className="tab-section-txt">SPECIFICATIONS:</h2>
        {speficicationData.map((item, index) => {
            const [label, value] = Object.entries(item)[0];

            return (
                <div className="section-txt-pdb" key={index}>
                    <strong>{capitalizeWordsRemoveDash(label)}:</strong>{" "}
                    <span className="sub-section-pdp">
                        {value}
                    </span>
                </div>
            );
        })}

    </>
    )
}
